import { render, $, toast, shareLink } from "../lib/ui";
import { icons } from "../lib/icons";
import { normalizeCode, isValidCode } from "../lib/words";

export interface LobbyHandlers {
  myCode: string;
  onCall: (code: string) => void;
}

export function showLobby({ myCode, onCall }: LobbyHandlers): void {
  render(`
    <div class="screen lobby">
      <div class="lobby-inner">
        <div class="code-block">
          <span class="label">Your code</span>
          <button class="code-display" id="my-code" title="Tap to copy">
            <span>${myCode}</span>
            <span class="code-copy">${icons.copy}</span>
          </button>
          <button class="text-action" id="copy-link">${icons.link} Share link</button>
        </div>

        <div class="dial">
          <input class="dial-input" id="peer-code" placeholder="Enter a code to call…"
            autocapitalize="off" autocomplete="off" spellcheck="false" />
          <button class="dial-btn" id="call-btn" title="Call">${icons.phone}</button>
        </div>

        <p class="tagline">Share your code, and anyone can call you.</p>
      </div>
    </div>
  `);

  $("#my-code").addEventListener("click", async () => {
    await navigator.clipboard.writeText(myCode);
    toast("Code copied");
  });

  $("#copy-link").addEventListener("click", async () => {
    await navigator.clipboard.writeText(shareLink(myCode));
    toast("Link copied");
  });

  const input = $("#peer-code") as HTMLInputElement;
  const submit = () => {
    const code = normalizeCode(input.value);
    if (!isValidCode(code)) {
      toast("Enter a code like brave-blue-tiger");
      return;
    }
    if (code === myCode) {
      toast("That's your own code");
      return;
    }
    onCall(code);
  };

  $("#call-btn").addEventListener("click", submit);
  input.addEventListener("keydown", (e) => {
    if ((e as KeyboardEvent).key === "Enter") submit();
  });
}
